import React from 'react'
import { TaskInput } from '../components/TaskInput';
import { TaskList } from '../components/TaskList';
import { useState, useEffect } from 'react'
import { onSnapshot,collection, doc, setDoc} from 'firebase/firestore';
import db from '../utils/firebase';
import { auth } from '../utils/firebase';
import { signOut } from 'firebase/auth';

export const Dashboard = () => {
    const [tasks, setTasks] = useState([])
    const [filteredTasks, setFilteredTasks] = useState(tasks)
    const [filterStatus, setFilterStatus] = useState("all")

    const [user, setUser] = useState({})
    const Logout = async () =>{
        await signOut(auth)
        window.location= "/"
    }

    // useEffect(()=> {
    //     //replace collection for doc(db,"users",uid.....somethong)
    //     const unsub = onSnapshot(collection(db,"tasks"), (snapshot)=> {
    //       let todos = snapshot.docs.map((doc)=> ({...doc.data(), id:doc.id}))
    //       setFilteredTasks(todos)
    //       const handleFilter = () => {
    //         if(filterStatus === "active") {
    //           setFilteredTasks(todos.filter((task)=> task.status === false))
    //         }
    //         else if(filterStatus === "completed") {
    //           setFilteredTasks(todos.filter((task)=> task.status === true))
    //         }
    //         else {
    //           setFilteredTasks(todos)
    //         }
    //       }
      
    //       handleFilter()
    //     })
    
    //     // Clean up function when the component unmounts remove the sideEffect
    //     return unsub
    
    //   }, [filterStatus])

    useEffect(()=>{
        //How to check if the user is logged in or authenticated
        auth.onAuthStateChanged((currentUser)=>{
            if(currentUser){
                //keep track of that user
                setUser(currentUser.uid)
            }else{
                console.log(currentUser)
                // window.Location = "/signup"
            }
        })
        // Grab the currentUser's tasks
        onSnapshot(doc(db,"Users",`${user}`), (snapshot)=>{
            // get the array of tasks
            let todos = snapshot.data().tasks
            const handleFilter = () => {
                        if(filterStatus === "active") {
                          setFilteredTasks(todos.filter((task)=> task.status === false))
                        }
                        else if(filterStatus === "completed") {
                          setFilteredTasks(todos.filter((task)=> task.status === true))
                        }
                        else {
                          setFilteredTasks(todos)
                        }
                      }
                  
                      handleFilter()
        })
        console.log(user)
        //onSnapshot
    },[user,filterStatus])


  return (
    <div className='Dashboard'>
        <div className='container'>
            <div className='header'>
            <h1>TODO</h1>
            <img src='./images/icon-sun.svg' alt='sun'/>
            </div>

            {/* ADD TO TASK INPUT COMPONENT */}
            <TaskInput 
            tasks = {tasks} 
            setTasks = {setTasks}
            userId = {user}
            filteredTasks ={filteredTasks}
            />

            {/* MAKE A TASK LIST COMPONENT */}
            <TaskList 
            tasks = {tasks}
            setTasks = {setTasks}
            filterStatus = {filterStatus}
            setFilterStatus = {setFilterStatus}
            filteredTasks = {filteredTasks}
            userId={user}
            />
        </div>
        <h3 onClick={Logout}>Logout</h3>
    </div>
  )
}
// import React from 'react'
// import { TaskInput } from '../components/TaskInput';
// import { TaskList } from '../components/TaskList';
// import { useState, useEffect } from 'react'
// import { onSnapshot,collection, doc,setDoc } from 'firebase/firestore';
// import db from '../utils/firebase';
// import { auth } from '../utils/firebase';
// import { signOut } from 'firebase/auth';

// export const Dashboard = () => {
//     const [tasks, setTasks] = useState([])
//     const [filteredTasks, setFilteredTasks] = useState(tasks)
//     const [filterStatus, setFilterStatus] = useState("all")
    
//     const [user,setUser] = useState({})

//     const logout = async () => {
//       await signOut(auth)
//       window.location = "/"
//     }
//     // useEffect(()=> {
//     //     const unsub = onSnapshot(collection(db,"tasks"), (snapshot)=> {
//     //       let todos = snapshot.docs.map((doc)=> ({...doc.data(), id:doc.id}))
//     //       setFilteredTasks(todos)
//     //       const handleFilter = () => {
//     //         if(filterStatus === "active") {
//     //           setFilteredTasks(todos.filter((task)=> task.status === false))
//     //         }
//     //         else if(filterStatus === "completed") {
//     //           setFilteredTasks(todos.filter((task)=> task.status === true))
//     //         }
//     //         else {
//     //           setFilteredTasks(todos)
//     //         }
//     //       }
      
//     //       handleFilter()
//     //     })
    
//     //     // Clean up function when the component unmounts remove the sideEffect
//     //     return unsub
    
//     //   }, [filterStatus])
    

//     useEffect(()=>{
//       // How to check if the user is logged in or authenticated?
//       auth.onAuthStateChanged((currentUser)=> {
        
//         if(currentUser) {
//           // keep track of that user
//           setUser(currentUser.uid);
//         } else {
//           // window.location = "/signup"
//         }

//       })

//       // Grab the currentUser's tasks
//       const unsub = onSnapshot(doc(db, "users", `${user}`), (snapshot)=> {
//         // get the array of tasks
//         let todos = snapshot.data().tasks

//         setFilteredTasks(todos)
//       })
//       // clean up
//       return unsub
//     },[user])


//     console.log(user)

    
//       return (
//         <div className="Dashboard">
    
//           <div className='container'>
    
//             <div className='header'>
//               <h1>TODO</h1>
//               <img src='./images/icon-sun.svg' alt='sun'/>
//             </div>
    
//             {/* ADD TO TASK INPUT COMPONENT */}
//            <TaskInput tasks = {tasks} setTasks = {setTasks} userId = {user} filteredTasks = {filteredTasks}/>
    
//             {/* MAKE A TASK LIST COMPONENT */}
//            <TaskList 
//             tasks = {tasks}
//             setTasks = {setTasks}
//             filterStatus = {filterStatus}
//             setFilterStatus = {setFilterStatus}
//             filteredTasks = {filteredTasks}
//             userId = {user}
//             />
//           </div>
//           <h3 onClick={logout}>Logout</h3>
//         </div>
//       );
// }














